import * as React from "react";
function SvgLinkedin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M7.36 4.57a2.75 2.75 0 11-2.73 2.75 2.74 2.74 0 012.73-2.75zM5 27.43V12.16h4.72v15.27zm7.67-15.27h4.53v2.09h.06a4.94 4.94 0 014.46-2.47c4.77 0 5.65 3.16 5.65 7.27v8.38h-4.71V20c0-1.77 0-4-2.45-4s-2.83 1.92-2.83 3.92v7.55h-4.71z"
        fill="#fffffe"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLinkedin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
